'use strict';
const _ = require('lodash');
const Backbone = require('backbone');
const template = require('../templates/css.ejs');

module.exports = Backbone.View.extend({
    tagName: 'style',
    className: 'view-css',
    initialize: function(options) {
        options = options || {};
        this.template = options.template ? options.template : template;
        this.style_id = options.style_id;
        this.namespace = options.namespace || '';
        this.namespaceModal = options.namespaceModal || '';
        this.uid = options.uid || '';
        this.model = _.extend(_.clone(this.model, 'true'), {
            namespace: this.namespace,
            namespaceModal: this.namespaceModal,
            uid: this.uid
        });

        // The CSS method from the Router has been called
        // Load any font family necessary
        if(this.namespace == '#'+this.uid) {
            var fonts = [];
            var objFonts = {};
            
            _.forEach(this.model.custom_font_urls, function(value, index) { 
                if(value['url'].length > 0)
                    fonts.push(value['url']);
            });

            for(var i = 0; i < fonts.length; i++) {
                objFonts[i] = fonts[i];
            };
            
            // this is to ensure the styles are updated properly
            var style = '.' + this.style_id;
            if(_.size(objFonts) > 0) {
                _.extend(this.model, {fonts: objFonts, styleID: style});
            } else {
                _.extend(this.model, {fonts: {}, styleID: style});                
            }
            
        }

        this.$el.prop('type', 'text/css');
        this.$el.prop('id', this.style_id);
    },
    /**
     *
     */
    render: function() {

        this.$el.append(this.template(this.model));

        return this;
    },
    /** 
     * 
     */
    remove: function() {
        this.template = null;
        this.namespace = null;
        this.namespaceModal = null;
        this.model = null;
        this.off();
        Backbone.View.prototype.remove.call(this);
    }
});


// WEBPACK FOOTER //
// ./app/scripts/views/css.js